import { constVoid } from 'fp-ts/function';
import { createContext } from 'react';
export var OnboardingContext = /*#__PURE__*/createContext({
  appVisibleBehindModal: true,
  enableAppVisibleBehindModal: constVoid
});